/**
 * ...
 * @author Robert Lombardo, Wakefield Studios ( rob@wakefield-studios.com )
 */
const Q_how_many_nearby_enemies_BASE = require('../questions/Q_how_many_nearby_enemies_BASE');
const Q_taunt_or_chain_pull = require('./Q_taunt_or_chain_pull');

const Q_nearby_enemies = function (actor, battleState, aggroNode, moveTowards) {
  const node = new Q_how_many_nearby_enemies_BASE(actor, battleState);

  // branch index
  node.ONE_OR_MORE = 1;

  node.branches[node.ZERO] = new Q_taunt_or_chain_pull(
    actor,
    battleState,
    moveTowards
  );

  node.branches[node.ONE_OR_MORE] = aggroNode;

  node.query = function () {
    const numNearby = this.calculateNearbyEnemies(1);

    if (numNearby === 0) {
      return this.branches[this.ZERO].query();
    } else {
      return this.branches[this.ONE_OR_MORE].query();
    }
  };

  return node;
};
module.exports = Q_nearby_enemies;
